import { render, staticRenderFns } from "./ShowM.vue?vue&type=template&id=8e4a33b2&scoped=true&"
import script from "./ShowM.vue?vue&type=script&lang=js&"
export * from "./ShowM.vue?vue&type=script&lang=js&"
import style0 from "./ShowM.vue?vue&type=style&index=0&id=8e4a33b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4a33b2",
  null
  
)

component.options.__file = "ShowM.vue"
export default component.exports